var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIconFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99967 14.6673C4.31777 14.6673 1.33301 11.6825 1.33301 8.00065C1.33301 4.31875 4.31777 1.33398 7.99967 1.33398C11.6815 1.33398 14.6663 4.31875 14.6663 8.00065C14.6663 11.6825 11.6815 14.6673 7.99967 14.6673ZM7.33301 10.0007V11.334H8.66634V10.0007H7.33301ZM8.66634 8.90405C9.63014 8.61718 10.333 7.72432 10.333 6.66732C10.333 5.37865 9.28834 4.33398 7.99967 4.33398C6.86767 4.33398 5.92392 5.14011 5.71122 6.20962L7.01887 6.47116C7.11007 6.0128 7.51454 5.66732 7.99967 5.66732C8.55194 5.66732 8.99967 6.11503 8.99967 6.66732C8.99967 7.21958 8.55194 7.66732 7.99967 7.66732C7.63147 7.66732 7.33301 7.96578 7.33301 8.33398V9.33398H8.66634V8.90405Z",
    fill: "#96999C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIconFilled);
export default __webpack_public_path__ + "static/media/question-icon-filled.282661760c5b43ff82812167adba3557.svg";
export { ForwardRef as ReactComponent };